import { Rate } from "../../margin/objects/rate";
import { CentralPayment } from "../objects/centralPayment";
import { CentralPaymentErrors } from "../objects/centralPaymentErrors";
import { CentralPaymentListConfiguration } from "../objects/centralPaymentListConfiguration";
import { CentralPaymentListCriteria } from "../objects/centralPaymentListCriteria";
import { CentralPaymentListFiltersCriteria } from "../objects/centralPaymentListFiltersCriteria";
import { Column } from "../objects/column";
import { MarginListCriteria } from "../objects/marginListCriteria";

export const CENTRAL_PAYMENT_MARGIN_MODULE = 'CENTRAL_PAYMENT_MARGIN_MODULE';

export const EMPTY_CENTRAL_PAYEMENT: CentralPayment = {
    name: '',
    code: '',
    street: '',
    zip_code: '',
    city: '',
    country: null,
    phone_number: '',
    iban: '',
    bic: '',
    id: 0,
    created_date: new Date(),
    modified_date: new Date(),
    creator: null,
    last_author: null,
    due_date: []
};

export const EMPTY_CENTRAL_PAYEMENT_FILTERS: CentralPaymentListFiltersCriteria = {
    name: '',
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    bic: "",
    iban: "",
    period: "MODIFICATION",
};

export const EMPTY_CENTRAL_PAYEMENT_LIST_CRITERIA: CentralPaymentListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_CENTRAL_PAYEMENT_FILTERS,
    search: ''
};

export const EMPTY_CENTRAL_PAYEMENT_ERRORS: CentralPaymentErrors = {
    name_error: '',
    iban_error: '',
    bic_error: ''
};

export const CENTRAL_PAYEMENT_INFO_ROUTE = '/central-payment/edit/:id/info';
export const CENTRAL_PAYEMENT_CONTACT_ROUTE = '/central-payment/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [{
    label: 'name',
    field_name: 'NAME',
    checked: true,
    order_by: 'name',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'central-payment-code',
    field_name: 'CODE',
    checked: true,
    order_by: 'code',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'iban',
    field_name: 'IBAN',
    checked: true,
    order_by: 'iban',
    fixed_width: false,
    last_updated: false,
    width: null
},
{
    label: 'bic',
    field_name: 'BIC',
    checked: true,
    order_by: 'bic',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: false,
    order_by: 'last_author__username',
    fixed_width: true,
    last_updated: false,
    width: null
}];

export const EMPTY_CENTRAL_PAYEMENT_LIST_CONFIGURATION: CentralPaymentListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

export const CENTRAL_PAYEMENT_MODULE = 'CENTRAL_PAYMENT';



export const EMPTY_CENTRAL_PAYMENT_MARGIN_LIST_CRITERIA: MarginListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    // filters: EMPTY_NETWORK_FILTERS,
    search: ''
};
export const MARGIN_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'content-types',
        field_name: 'CONTENT_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'margin-type',
        field_name: 'MARGIN_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'surcommission',
        field_name: 'SURCOMMISSION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'currency',
        field_name: 'CURRENCY',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: false,
        order_by: 'start_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: false,
        order_by: 'end_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
        width: null
    }, {
        label: 'activated',
        field_name: 'ACTIVATED',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
        width: null
    }
];

export const EMPTY_CENTRAL_PAYMENT_MARGIN_LIST_CONFIGURATION: CentralPaymentListConfiguration = {
    columns: MARGIN_COLUMN,
    preferences: []
};

export const EMPTY_RATE: Rate = {
    applied_under: null,
    currency: null,
    rate: 0,
    rate_type: 'FIX'
};